export const Utils = {
	isNotNull<T>(value: T | null | undefined): value is T {
		return value !== null && value !== undefined
	},

	associateWith<K extends keyof any, V>(arr: V[], selector: (value: V) => K): Record<K, V> {
		return Object.fromEntries(arr.map(k => [selector(k), k])) as any // jfc typescript
	}
}

